import { createElement, type SVGProps } from 'react';
import { SvgTicket } from './Ticket';

export {
  SvgAddPlayer as AddPlayer,
  SvgAddPlayerDimension as AddPlayerDimension,
} from './AddPlayer';
export { SvgAssist as Assist, SvgAssistDimension as AssistDimension } from './Assist';
export { SvgCaptain as Captain, SvgCaptainDimension as CaptainDimension } from './Captain';
export {
  SvgChevronLeft as ChevronLeft,
  SvgChevronLeftDimension as ChevronLeftDimension,
} from './ChevronLeft';
export {
  SvgArrowLeft as ArrowLeft,
  SvgArrowLeftDimension as ArrowLeftDimension,
} from './ArrowLeft';
export { SvgBooster as Booster, SvgBoosterDimension as BoosterDimension } from './Booster';
export { SvgCaretUp as CaretUp, SvgCaretUpDimension as CaretUpDimension } from './CaretUp';
export {
  SvgCaretDown as CaretDown,
  SvgCaretDownDimension as CaretDownDimension,
} from './CaretDown';
export {
  SvgChevronUp as ChevronUp,
  SvgChevronUpDimension as ChevronUpDimension,
} from './ChevronUp';
export {
  SvgChevronDown as ChevronDown,
  SvgChevronDownDimension as ChevronDownDimension,
} from './ChevronDown';
export {
  SvgCloseRounded as CloseRounded,
  SvgCloseRoundedDimension as CloseRoundedDimension,
} from './CloseRounded';
export { SvgCopy as Copy, SvgCopyDimension as CopyDimension } from './Copy';
export { SvgGoal as Goal, SvgGoalDimension as GoalDimension } from './Goal';
export {
  SvgGoalBonus as GoalBonus,
  SvgGoalBonusDimension as GoalBonusDimension,
} from './GoalBonus';
export { SvgInfo as Info, SvgInfoDimension as InfoDimension } from './Info';
export { SvgInjured as Injured, SvgInjuredDimension as InjuredDimension } from './Injured';
export { SvgLoading as Loading, SvgLoadingDimension as LoadingDimension } from './Loading';
export {
  SvgPenaltyMiss as PenaltyMiss,
  SvgPenaltyMissDimension as PenaltyMissDimension,
} from './PenaltyMiss';
export {
  SvgPenaltySave as PenaltySave,
  SvgPenaltySaveDimension as PenaltySaveDimension,
} from './PenaltySave';
export { SvgReset as Reset, SvgResetDimension as ResetDimension } from './Reset';
export { SvgSearch as Search, SvgSearchDimension as SearchDimension } from './Search';
export { SvgShield as Shield, SvgShieldDimension as ShieldDimension } from './Shield';
export {
  SvgSquareCheck as SquareCheck,
  SvgSquareCheckDimension as SquareCheckDimension,
} from './SquareCheck';
export { SvgSquare as Square, SvgSquareDimension as SquareDimension } from './Square';
export { SvgTicket as Ticket, SvgTicketDimension as TicketDimension } from './Ticket';
export { SvgTransfer as Transfer, SvgTransferDimension as TransferDimension } from './Transfer';
export {
  SvgTransferInOut as TransferInOut,
  SvgTransferInOutDimension as TransferInOutDimension,
} from './TransferInOut';
export {
  SvgUnavailable as Unavailable,
  SvgUnavailableDimension as UnavailableDimension,
} from './Unavailable';
export {
  SvgViceCaptain as ViceCaptain,
  SvgViceCaptainDimension as ViceCaptainDimension,
} from './ViceCaptain';

export const YellowTicket = (props: SVGProps<SVGSVGElement>) =>
  createElement(SvgTicket, { ticketType: 'yellow', ...props });

export const RedTicket = (props: SVGProps<SVGSVGElement>) =>
  createElement(SvgTicket, { ticketType: 'red', ...props });
